<template>
  <div class="material-select" :class="{ disabled }">
    <span
      class="select-label"
      :class="{ active: !!value }"
      v-if="mode === 'normal'"
      >{{ placeholder }}</span
    >

    <span
      class="tableHeader"
      :class="{ placeholder: !is_one_of_possible_values }"
      v-if="mode === 'tableHeaderCell'"
    >
      {{ placeholder }}
      <i class="material-icons" v-show="value && value.includes('DESC')"
        >arrow_downward</i
      >
      <i class="material-icons" v-show="value && value.includes('ASC')"
        >arrow_upward</i
      >
    </span>

    <b-dropdown
      :text="selectedText"
      v-if="options"
      :class="{
        placeholder: selectedText === placeholder || !is_one_of_possible_values,
      }"
      :disabled="disabled"
    >
      <b-dropdown-header v-if="header" class="title">{{
        header
      }}</b-dropdown-header>

      <b-dropdown-item
        :class="{ selected: value === option.value }"
        @click="onChange(option.value)"
        v-for="option of options"
        :key="option.value"
      >
        {{ option.text }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    options: [Array, Object],
    header: String,
    value: [String, Number, Object],
    onChange: Function,
    placeholder: String,
    mode: {
      type: String,
      default: 'normal',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    possible_values() {
      return this.options.map(opt => opt.value) || [];
    },
    is_one_of_possible_values() {
      return this.possible_values.includes(this.value);
    },
    selectedText() {
      if (this.mode === 'tableHeaderCell') return '';

      if (!this.value || !this.is_one_of_possible_values) {
        return this.placeholder;
      }

      const option = this.options.find(opt => opt.value === this.value);
      return option.text;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.material-select {
  position: relative;
  padding-top: 15px;

  &.disabled {
    pointer-events: none;
    opacity: 0.7;
  }

  .tableHeader {
    pointer-events: none;
    position: relative;
    top: 9px;

    i {
      position: relative;
      top: 4px;
      left: 2px;
      font-size: 16px;
    }

    + .dropdown {
      margin-top: -38px;
    }

    &.placeholder {
      color: #c2c7d4;
      i {
        visibility: hidden;
      }
    }
  }

  > .material-icons {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .select-label {
    position: absolute;
    opacity: 0;
    transition: opacity 0.2s;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    top: 1px;
    pointer-events: none;
    color: #929da9;
    margin: 0;

    &.active {
      opacity: 1;
    }
  }

  .placeholder {
    ::v-deep .btn.dropdown-toggle {
      color: #929da9 !important;
    }
  }
}
</style>
